import React, { useEffect, useState } from 'react'
import { useFetchSimilarAnswersQuery } from '../../../../../../../../../store/apis/submission.api'
import { Button, Flex, List } from 'antd'
import Editor from '../../../../../../../../../components/common/Editor/Editor'
import { LANGUAGES } from '../../../../../../../../../constants/languages'
import Text from 'antd/es/typography/Text'
import PatternIcon from '../../../../../../../../../components/common/PatternIcon'

const useOffset = (dependencies = []) => {
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        setOffset(0)
    }, dependencies)

    const incrementOffset = (incrementBy = 3) => {
        setOffset(prevOffset => prevOffset + incrementBy)
    }

    return [offset, incrementOffset]
}

const SimilarAnswers = ({ answer, question }) => {
    const [offset, incrementOffset] = useOffset([answer.id, question.id])
    const { data: similarAnswers, isFetching: isFetchingSimilarSubmissions } = useFetchSimilarAnswersQuery({
        id: answer.id,
        offset,
    })

    const onLoadMore = () => incrementOffset()

    const loadMore = !isFetchingSimilarSubmissions ? (
        <Flex justify='center' className='f-width mt-8'>
            <Button onClick={onLoadMore}>Load more</Button>
        </Flex>
    ) : null

    return (
        <List
            dataSource={similarAnswers}
            loadMore={loadMore}
            style={{ maxHeight: 400, overflow: 'auto' }}
            loading={{ spinning: isFetchingSimilarSubmissions, tip: 'Loading similar answers...' }}
            renderItem={answer => {
                const category = question?.categories.find(category => category.id === answer.categoryId)
                return (
                    <List.Item>
                        <List.Item.Meta
                            description={
                                <Editor
                                    value={answer.text}
                                    language={LANGUAGES.NEW_TEXT.value}
                                    title={
                                        <Flex justify='space-between'>
                                            <Text type='secondary' submission-name={answer.name}>
                                                <PatternIcon
                                                    id={answer.categoryId}
                                                    colorId={category?.colorId}
                                                    showId={false}
                                                />{' '}
                                                {category?.name}
                                                {' '}ID: {answer.id}
                                            </Text>
                                            <Text type='secondary'>
                                                Similarity score: {Math.round(answer.confidence * 100)}%
                                            </Text>
                                        </Flex>
                                    }
                                    readOnly
                                    showActions={false}
                                    wrapperStyles={{ height: '100%' }}
                                    showLineNumbers={false}
                                />
                            }
                        />
                    </List.Item>
                )
            }}
        />
    )
}

export default SimilarAnswers
